//Room spec
export const RECEIVE_INPUT_FILE = "RECEIVE_INPUT_FILE";
export const REQUEST_INPUT_FILE = "REQUEST_INPUT_FILE";
export const INCORRECT_INPUT_PASSED = "INCORRECT_INPUT_PASSED";
export const INPUT_TEXT_AREA_UPDATED = "INPUT_TEXT_AREA_UPDATED";
export const ROOM_SPEC_UPDATED = "ROOM_SPEC_UPDATED";
export const ROBOT_SPEC_UPDATED = "ROBOT_SPEC_UPDATED";

// Robot movements
export const MOVE_ROBOT_EAST = "MOVE_ROBOT_EAST";
export const MOVE_ROBOT_WEST = "MOVE_ROBOT_WEST";
export const MOVE_ROBOT_NORTH = "MOVE_ROBOT_NORTH";
export const MOVE_ROBOT_SOUTH = "MOVE_ROBOT_SOUTH";

// Robot actions
export const REMOVE_DIRT_PATCH = "REMOVE_DIRT_PATCH";
export const DIRT_PATCH_REMOVED = "DIRT_PATCH_REMOVED";
export const SET_ROBOT_COORDINATES = "SET_ROBOT_COORDINATES";
export const ROBOT_NAVIGATION_STARTED = "ROBOT_NAVIGATION_STARTED";
export const ROBOT_NAV_STEP_COMPLETED = "ROBOT_NAV_STEP_COMPLETED";
export const ROBOT_ANIM_STARTED = "ROBOT_ANIM_STARTED";
export const ROBOT_ANIM_ENDED = "ROBOT_ANIM_ENDED";



// WEBPACK FOOTER //
// ./src/actions/ActionTypes.js